import { render, staticRenderFns } from "./LabourerReadinessDashboard.vue?vue&type=template&id=f479c518&scoped=true&"
import script from "./LabourerReadinessDashboard.vue?vue&type=script&lang=js&"
export * from "./LabourerReadinessDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LabourerReadinessDashboard.vue?vue&type=style&index=0&id=f479c518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f479c518",
  null
  
)

export default component.exports